import styled from 'styled-components';
import { grey } from '@material-ui/core/colors';

export const StoreItemWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  border: 1px solid ${grey[200]};
  border-radius: 0.25em;
  margin-bottom: 1em;
`;

export const StoreItemInfo = styled.div`
  display: flex;
  flex-flow: row wrap;
  flex: 1 1 auto;
  align-items: center;
  padding: 0.5rem 1rem;
`;

export const StoreItemActions = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  border-left: 1px solid ${grey[200]};
  padding: 0.5rem;
`;

export const StoreItemText = styled.p`
  color: ${grey[800]};
  font-size: 1.4em;
  font-weight: 600;
  margin: 0;
`;

export const StoreItemTitle = styled.p`
  color: ${grey[600]};
  font-size: 1em;
  font-weight: 300;
  margin: 0;
`;

export const StoreItemIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 0 0.5rem;
`;

export const AmountFieldWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  border: 1px solid var(--border-color);
  .MuiInputBase-root {
    max-width: 50px;
    input {
      text-align: center;
    }
  }
`;

export const AmountFieldBtn = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  min-height: 2rem;
  min-width: 3rem;
`;
